import { __awaiter } from "tslib";
import { useEffect, useMemo, useState } from 'react';
import { OverlayContainer } from './overlayContainer';
import { createContainer } from 'unstated-next';
import { DesiredGfxState } from './useGfxState';
import { Ads } from './adsContainer';
import camelCase from 'camelcase';
const useManual = () => {
    var _a;
    const { overlay, manualState, match } = OverlayContainer.useContainer();
    const { dispatch, state } = DesiredGfxState.useContainer();
    const { getNextAd } = Ads.useContainer();
    const [theme, setTheme] = useState();
    const loadThemeFn = (sport, themeName = 'default') => __awaiter(void 0, void 0, void 0, function* () {
        const { loadTheme } = (yield import(`@ligr/themes/lib/${camelCase(sport)}/index.js`)).default;
        const theme = (yield loadTheme(themeName)).default;
        setTheme(theme);
    });
    useEffect(() => {
        var _a;
        if ((_a = match === null || match === void 0 ? void 0 : match.competition) === null || _a === void 0 ? void 0 : _a.sport.name) {
            loadThemeFn(match.competition.sport.name);
        }
    }, [(_a = match === null || match === void 0 ? void 0 : match.competition) === null || _a === void 0 ? void 0 : _a.sport.name]);
    const autoAdAdjustedManualState = useMemo(() => {
        return Object.entries(manualState).reduce((updated, [graphicName, graphicProps]) => {
            var _a, _b;
            if (!theme) {
                return updated;
            }
            const currentProps = state.desiredState[graphicName] || {};
            if (!(graphicProps === null || graphicProps === void 0 ? void 0 : graphicProps.adSize) ||
                !(graphicProps === null || graphicProps === void 0 ? void 0 : graphicProps.adSetId) ||
                (graphicProps === null || graphicProps === void 0 ? void 0 : graphicProps.adSize) === 'none' ||
                (graphicProps === null || graphicProps === void 0 ? void 0 : graphicProps.adSetId) === 'none') {
                return Object.assign(Object.assign({}, updated), { [graphicName]: Object.assign(Object.assign({}, graphicProps), { adSize: undefined, adSetId: undefined }) });
            }
            let autoAd;
            if (graphicProps.adSize !== 'auto' && graphicProps.adSetId === 'auto') {
                // If we are still just on auto and the size hasn't changed and we already have a url keep showing that.
                if (currentProps.adSize === graphicProps.adSize && currentProps.autoAdSet && currentProps.adUrl) {
                    graphicProps = Object.assign(Object.assign({}, graphicProps), { adUrl: currentProps.adUrl, adSetId: currentProps.adSetId, adSize: currentProps.adSize, autoAdSet: true });
                }
                else {
                    autoAd = getNextAd(Object.assign(Object.assign({}, graphicProps), { adSizes: [graphicProps.adSize], adSetId: undefined })) || { adSize: undefined, adSetId: undefined };
                }
            }
            else if (graphicProps.adSize === 'auto' && graphicProps.adSetId !== 'auto') {
                if (currentProps.autoAdSize && graphicProps.adSetId === currentProps.adSetId && currentProps.adUrl) {
                    graphicProps = Object.assign(Object.assign({}, graphicProps), { adUrl: currentProps.adUrl, adSetId: currentProps.adSetId, adSize: currentProps.adSize, autoAdSize: true });
                }
                else {
                    autoAd = getNextAd(Object.assign(Object.assign({}, graphicProps), { adSizes: ((_a = theme.graphics.find(({ name }) => camelCase(name) === graphicName)) === null || _a === void 0 ? void 0 : _a.imageAdSizes) || undefined, adSetId: graphicProps.adSetId })) || { adSize: undefined, adSetId: undefined };
                }
            }
            else if (graphicProps.adSize === 'auto' && graphicProps.adSetId === 'auto') {
                if (currentProps.autoAdSize && currentProps.autoAdSet && currentProps.adUrl) {
                    graphicProps = Object.assign(Object.assign({}, graphicProps), { adUrl: currentProps.adUrl, adSetId: currentProps.adSetId, adSize: currentProps.adSize, autoAdSize: true, autoAdSet: true });
                }
                else {
                    autoAd = getNextAd(Object.assign(Object.assign({}, graphicProps), { adSizes: ((_b = theme.graphics.find(({ name }) => camelCase(name) === graphicName)) === null || _b === void 0 ? void 0 : _b.imageAdSizes) || undefined, adSetId: undefined })) || { adSize: undefined, adSetId: undefined };
                }
            }
            updated[graphicName] = Object.assign(Object.assign({}, graphicProps), autoAd);
            return updated;
        }, {});
    }, [manualState, theme]);
    useEffect(() => {
        if (!(overlay === null || overlay === void 0 ? void 0 : overlay.autoMode)) {
            dispatch({
                type: 'APPLY_MANUAL_STATE',
                src: 'MANUAL_UPDATE',
                payload: autoAdAdjustedManualState
            });
        }
    }, [autoAdAdjustedManualState, overlay === null || overlay === void 0 ? void 0 : overlay.autoMode]);
};
export const Manual = createContainer(useManual);
//# sourceMappingURL=manualContainer.js.map